import Loader from 'components/atoms/loader';
import BiddingItemNew from 'components/molecules/bidding_item_new';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import companyId from 'services/company_id';
import { ApplicationState } from 'store';
import { getBidding } from 'store/modules/bidding_store/actions';
import { BiddingState, BiddingData } from 'store/modules/bidding_store/types';
import { ProfileState } from 'store/modules/profile_store/types';

interface BiddingNotificationDetailsProps {
  params: {
    id?: string;
  };
}

const BiddingNotificationDetails = (props: BiddingNotificationDetailsProps) => {
  const { params } = props;
  const { id = '' } = params;

  const dispatch = useDispatch();

  const { biddings, request } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [bidding, setBidding] = useState<BiddingData | null>(null);

  useEffect(() => {
    const currentBidding = biddings?.bidding_list?.find((bidding) => bidding.id.toString() === id);
    if (currentBidding) setBidding(currentBidding);
    if (!currentBidding) dispatch(getBidding(id, companyId(profile)));
  }, [id]);

  useEffect(() => {
    document.title = `Detalhes da licitação nº ${id} - ConLicitação`;
  }, []);

  useEffect(() => {
    if (request.get_bidding.loading) return;

    const currentBidding = biddings?.bidding_list?.find((bidding) => bidding.id.toString() === id);
    if (currentBidding) setBidding(currentBidding);
  }, [
    request.get_bidding,
    biddings?.bidding_list?.find((bidding) => bidding.id.toString() === id),
  ]);

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        {request.get_bidding.loading && (
          <div className="d-flex align-items-center justify-content-center loading-container">
            <Loader />
          </div>
        )}
        {!request.get_bidding.loading && (
          <div className="row mb-4 px-md-4 py-4">
            <div className="col-12">
              <div className="row mb-4">
                <div className="col-12 p-0 d-flex justify-content-between">
                  <h4>Detalhes da licitação nº {id}</h4>
                </div>
              </div>
              {bidding && (
                <BiddingItemNew
                  bidding={bidding}
                  biddingIndex={0}
                  source="biddingDetails"
                  isChecked={false}
                  toggleSelected={() => {}}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BiddingNotificationDetails;
